import { render, staticRenderFns } from "./DeclDocument.vue?vue&type=template&id=15d1b294&scoped=true"
import script from "./DeclDocument.vue?vue&type=script&lang=ts"
export * from "./DeclDocument.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15d1b294",
  null
  
)

export default component.exports